// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"427":"77a71493e14c364a","839":"77a9d891b999c7f5"}[chunkId] + ".js";
};